import { Component, OnInit } from '@angular/core';
import { Observable, AppState, Store, AppFields, AppTypes, ProgramsBillingType, map, AutoUnsubscribe, Organization, OrgTeam, switchMap, filter, take, StorageUtil } from '../../store';
import { AssociationRegistrationService, MyTeamsService } from '../../services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router, NavigationEnd } from '@angular/router';
import { ClubTeamsService } from '../../services/club-teams.service';
import { Subscription } from 'rxjs/Subscription';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public adminURLRedirect = 'https://admin.totalglobalsports.com/';
  public publicAuthSignURLRedirect = 'https://public.totalglobalsports.com/auth/roles-select';
  isBasketballClub: boolean;
  isStaffEvaluations = false;
  modalOpened = false;
  modalOpenedChangingAffilation = false;
  user: any;
  public myTeam;
  public teamTypeList: any[] = [];
  public club: any;
  teamBirthYear;

  constructor(
    private store: Store<any>,
    private assoService: AssociationRegistrationService,
    private service: MyTeamsService,
    private loader: Ng4LoadingSpinnerService,
    private router: Router,
    private ts: ClubTeamsService
  ) {
    let clubID;
    this.store.select(AppFields.App, AppFields.Club).pipe(
      filter(c => !!c),
      switchMap(c => c && c.clubID && (clubID = c.clubID, this.assoService.checkClubSportIsBasketball(c.clubID)))
    ).pipe(take(1)).subscribe(r => this.isBasketballClub = r);

    this.store.select(AppFields.App, AppFields.User).subscribe(rs => {
      this.user = rs;
    });
    this.store.select(AppFields.App, AppFields.EvalautionAccount).subscribe(rs => {
      this.isStaffEvaluations = rs;

    });
    this.store.select(AppFields.App, AppFields.MyTeam).subscribe(team => {
      this.myTeam = team;
      if (team) {
        this.getTeamPlayerList();
      }
    });
  }

  isEditTeamDisplay: boolean = false;
  public subscription: Subscription = new Subscription();
  isShowChangePassword: boolean;

  ngOnInit() {
    if (window.location.href.includes('http://clubbilling.dev') || window.location.href.includes('localhost:')) {
      this.adminURLRedirect = 'https://admin.totalglobalsports.com/registration.aspx';
      this.publicAuthSignURLRedirect = 'http://public.dev.totalglobalsports.com/auth/roles-select';
    }
    if (StorageUtil.roleId == 3 || StorageUtil.roleId == 7) {
      this.isShowChangePassword = true;
    } else {
      this.isShowChangePassword = false;
    }
    this.getTeamTypeList();
    this.subscription.add(
      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          if (event.url.includes('/team/dashboard')) {
            this.isEditTeamDisplay = true;
          } else {
            this.isEditTeamDisplay = false;
          }

        })
    );

  }

  ngOnDestroy() {
    this.modalOpened = false;
    this.modalOpenedChangingAffilation = false;
  }
  getTeamTypeList() {
    this.loader.show();
    let data = this.service.getTeamType().subscribe((rs: any) => {
      this.loader.hide();
      this.teamTypeList = rs.data;
      data.unsubscribe();
    });
  }
  onOpenEditTeam() {
    this.onEditTeam();
    this.modalOpened = true;
  }
  onEditTeam() {
    this.loader.show();
    let data = this.service.getIndividualTeamInfoByTeam(this.myTeam.teamID).subscribe((rs: any) => {
      this.loader.hide();
      this.club = rs;
      let teamName = rs.teamName.replace(rs.clubName, "");
      let name = teamName.replace(' - ', "");
      this.teamName = name.trim();//rs.teamName.substring(rs.teamName.indexOf("-") + 1);
      this.orgTeamName = rs.teamName;
      this.teamClubID = rs.teamClubID;
      this.gender = this.club.teamGender;
      this.traceAutoSyncID = this.club.traceTeamAutoSyncID;
      this.teamTypeID = this.club.teamTypeID;
      this.clubID = this.club.clubID;
      this.clubLogo = this.club.clubLogo;
      this.teamBirthYear = rs.teamBirthYear;
      data.unsubscribe();
    });
  }
  states: any[];
  clubs: any[];
  clubLogo: string;
  clubsAffilation: any;
  getStates() {
    this.clubs = [];
    this.clubsAffilation = "";
    this.loader.show();
    let data = this.service.getStates().subscribe((response: any) => {
      this.loader.hide();
      this.states = response;
      this.modalOpenedChangingAffilation = true;
      data.unsubscribe();
    });
  }
  onStateSelected(e) {
    let stateID = +e.target.value;
    this.clubsAffilation = "";

    this.loader.show();
    let data = this.service.getClubListByStateID(stateID).subscribe((response: any) => {
      this.loader.hide();
      this.clubs = response;
      data.unsubscribe();
    });
  }

  onClubSelected(e) {
    let clubID = e.target.value;
    this.clubsAffilation = this.clubs.find(x => x.clubID == clubID);
    this.clubID = clubID;
    //this.clubsAffilation = club;
  }
  gender: string;
  teamName: string;
  orgTeamName: string;
  traceAutoSyncID: string;
  teamTypeID: number;
  teamClubID: number;
  clubID: number;

  onTeamSave(isTeam) {
    let obj = {
      "TeamID": StorageUtil.teamId,
      "TeamName": this.teamName.trim(),
      "ClubName": this.clubsAffilation ? this.clubsAffilation.clubName : this.club.clubName,
      "TeamGender": this.gender,
      "TeamTypeID": +this.teamTypeID,
      "TraceTeamAutoSyncID": this.traceAutoSyncID,
      "ClubID": this.clubID,
      "TeamClubID": this.teamClubID,
      "HasClubChanged": +isTeam == 0 ? 1 : 0,
      "HasTeamChanged": +isTeam == 1 ? 1 : 0,
      teamBirthYear: this.teamBirthYear,
      teamBirthYearDateupdatedBy: this.teamBirthYear ? StorageUtil.userID : null,
    }

    this.loader.show();
    let data = this.service.editTeamInformation(obj).subscribe((response: any) => {
      this.loader.hide();
      this.getClubTeamsList();
      if (isTeam == 1) {
        this.modalOpened = false;
      }
      this.modalOpenedChangingAffilation = false;
      this.onEditTeam();
      data.unsubscribe();
    });
  }

  getClubTeamsList() {
    localStorage.setItem('teamGender', this.gender);
    this.loader.show();
    this.ts.getClubTeamsList(this.clubID, 1, 0).subscribe(
      teams => {
        this.getAdminTeamClubData();
        this.loader.hide();
        //this.myTeam = teams;
        this.store.dispatch({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.MyTeam]: StorageUtil.teamId ? teams.find(t => t.teamID === StorageUtil.teamId) || null : null
          }
        });
      }
    );
  }
  getTeamPlayerList() {
    this.store.select(AppFields.App, AppFields.GetTeamPlayerList).subscribe(teamPlayerList => {
      if (teamPlayerList == null || teamPlayerList == undefined || teamPlayerList == "") {
        this.store.dispatch({
          type: AppTypes.GetTeamPlayerList,
          payload: {
            teamID: StorageUtil.teamId ? StorageUtil.teamId || null : null
          }
        });
      }
    });
  }
  getAdminTeamClubData() {
    this.loader.show();
    this.service.getAdminTeamClubData(this.club.teamID).subscribe((club: any) => {
      this.loader.hide();
      localStorage.setItem('clubId', club.clubID);
      this.store.dispatch({
        type: AppTypes.InitializeClub,
        payload: {
          clubId: club.clubID
        }
      });
    });
  }
  onCancel() {
    this.clubsAffilation = "";
    this.modalOpenedChangingAffilation = false
  }
  get changeRoleLink() {
    return this.publicAuthSignURLRedirect;
  }

  get legacySystemLink() {
    return this.adminURLRedirect + 'TeamAdmin/Teams.aspx';
  }

  get myTeams(): boolean {
    return (
      this.myTeam
    );
  }

  logout() {
    localStorage.clear();
    window.location.href = "https://public.totalglobalsports.com/auth/sign-in";
    //window.location.href = this.adminURLRedirect + 'public/registration.aspx';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts